<!--
右下角浮动按钮
最近更新：20200318
-->
<template>
<div class="page_top">
  <div class="app_wrap">
    <div class="cover_wrap">
      <div class="cover image"
        v-lazy:background-image="{
          src: './static/img/app.png',
          error: './static/img/img_blank.png'
        }"
      ></div>
    </div>
    <div class="title_wrap">
      <div class="title">捷安特App</div>
      <div class="subtitle">绑定爱车请打开捷安特骑行App</div>
    </div>
  </div>
  <a href="http://appdownload.giant.com.cn/" class="btn btn_color_1 btn_shadow">打开App</a>
  <a class="btn btn_close" @click="$store.state.SHOW_DOWNLOAD=false"><i class="material-icons">&#xe5cd;</i></a>
</div>
</template>

<script>

export default {
  name: 'PageTop',
  components: {},
  props: [],
  data () {
    return {
      tmpName: 'PageTop',
    }
  },
  computed: {},
  watch: {},
  created() {
    const _this = this;
  },
  mounted() {
  },
  destroyed() {},
  methods: {
    funBack(){
      this.$router.go(-1);
    },
  }
}
</script>

<style lang="less">
.page_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 10px 35px 10px 20px;
  position: relative;
  z-index: 10;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 30%);
  .app_wrap {
    flex: 1;
    display: flex;
    align-items: center;
    .cover_wrap {
      flex-shrink: 0;
      border-radius: 3px;
      overflow: hidden;
      background-color: #fff;
      width: 40px;
      height: 40px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 30%);
      .cover {
        width: 40px;
        height: 40px;
      }
    }
    .title_wrap {
      padding-left: 10px;
      .title {
        font-size: 14px;
        font-weight: bold;
      }
      .subtitle {
        color: #999;
      }
    }
  }
  .btn {
    flex-shrink: 0;
    line-height: 30px;
    padding: 0 10px;
  }
  .btn_close {
    position: absolute;
    top: -5px;
    right: 0;
    color: #999;
    i {
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageTop.vue